import { initDataTypes } from "@lcap/basic-template";

export default {
  install(Vue, options) {
    initDataTypes(options);
  },
};
